import React from "react";
import { FaFilePdf, FaFileWord, FaFileExcel, FaFileImage, FaFileAlt } from "react-icons/fa";
import { viewDocument } from "../../helpers/documentFile";

const fileIcon = (type = "") => {
    if (type === "application/pdf") return { Icon: FaFilePdf, color: "#d9534f" };
    if (type.includes("word")) return { Icon: FaFileWord, color: "#2b579a" };
    if (type.includes("excel") || type.includes("spreadsheet")) return { Icon: FaFileExcel, color: "#217346" };
    if (type.startsWith("image/")) return { Icon: FaFileImage, color: "#6f42c1" };
    return { Icon: FaFileAlt, color: "#6c757d" };
};

// File type icon that opens the document (replaces the View button)
const DocumentFileIcon = ({ doc }) => {
    const { Icon, color } = fileIcon(doc.type);

    return (
        <a
            href="javascript:;"
            className="mr-3"
            title={"View " + (doc.original_name || "")}
            onClick={() => viewDocument(doc)}
        >
            <Icon size={22} color={color} />
        </a>
    );
};

export default DocumentFileIcon;
